module.exports = __webpack_public_path__ + "static/img/48060.0fc7868.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/48060.jpg
// module id = +IUo
// module chunks = 1